export class FormSectionDescriptor {
    id: number;
    caption: string;
    fields: any[];

    constructor(id: number, caption: string) {
        this.id = id;
        this.caption = caption;
    }
}
